import React from 'react';
import { StyledLabel } from './styles';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
    inline?: boolean;
};

const Label: React.FC<LabelProps> = ({ children, inline, ...otherProps }) => {
    const inlinePresent = inline !== undefined;
    return (
        <StyledLabel $inlinePresent={inlinePresent} {...otherProps}>
            {children}
        </StyledLabel>
    );
};

export default Label;
